<template>
    <div>
        <forms-templates-grid :returnUrl="returnUrl">
        </forms-templates-grid>
    </div>
</template>

<script>
    import FormsTemplatesGrid from "@/components/forms/FormsTemplatesGrid";

    export default {
        name: 'FormsTemplatesList',
        components: {
            FormsTemplatesGrid
        },
        data() {
            return {
                returnUrl: '/forms/templates'
            }
        }
    }
</script>

<style scoped>
</style>
